<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <h6>Listado de Evaluaciones de Cumplimiento Legales</h6>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="6" sm="6" md="2">
                            <v-select dense v-model="filtroestado" :items="estado" label="Estado" item-text="detalle"
                                item-value="valor"></v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="2">
                            <v-select dense v-model="filtrotipo" :items="tipos" label="Tipo" item-text="detalle"
                                item-value="valor"></v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Sitio" dense v-model="filtrositio">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Referencia" dense v-model="filtroreferencia">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="2">
                            <v-text-field label="Evaluador" dense v-model="filtroevaluador">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="space-around">
                        <v-btn tile color="success" @click="cargarListado()">
                            <v-icon left> mdi-magnify </v-icon>
                            Buscar
                        </v-btn>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                :items-per-page="4000" hide-default-footer :loading="loadtable"
                loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                <template v-slot:item.ver="{ item }">

                    <v-icon small color="blue" class="mr-2" @click.stop="verInforme(item)">
                        mdi-eye
                    </v-icon>
                    <v-icon small color="blue" class="mr-2" @click.stop="editarInforme(item)">
                        mdi-pencil
                    </v-icon>
                    <v-icon small color="purple" class="mr-2" @click.stop="generarInforme(item)">
                        mdi-content-copy
                    </v-icon>
                </template>
            </v-data-table>
            <VerInforme :visible="showInforme" :codeval="editedItem.codigo" @close="showInforme = false"></VerInforme>
            <EditarInforme :visible="showEditar" :codeval="editedItem.codigo" @close="showEditar = false">
            </EditarInforme>
            <Generar :visible="showGenerar" :codeval="editedItem.codigo" @close="showGenerar = false"></Generar>
        </v-app>
    </div>
</template>
<style scoped>
.font-class-name2 {
    font-size: 12px !important;
}

::v-deep .v-data-table .v-data-table__wrapper td {
    font-size: 12px !important;
    padding: 2px 4px !important;
}

::v-deep .v-data-table .v-data-table-header tr th {
    font-size: 12px !important;
    padding: 2px 4px !important;
}
</style>
<script>
import axios from "../../../axios-auth.js";
import VerInforme from "../Requisitos/Informeevaluacion.vue";
import EditarInforme from "../Requisitos/Editarevaluacion.vue"
import Generar from "../Requisitos/Generarevaluacion.vue";
import moment from "moment";
export default {
    components: { EditarInforme, Generar, VerInforme },
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        filtroestado: "",
        filtroevaluador: "",
        filtrotipo: "",
        filtroreferencia: "",
        filtrositio: "",
        listado: [],
        estado: [{ detalle: "Pendiente", valor: "P" },
        { detalle: "Cerrado", valor: "C" },
        { detalle: "Todas", valor: "" },
        ],
        tipos: [
            { detalle: "MA Nacional", valor: "MAN" },
            { detalle: "MA Provincia de Córdoba", valor: "MAP" },
            { detalle: "MA Municipalidad de Córdoba", valor: "MAM" },
            { detalle: "MA CABA", valor: "MACABA" },
            { detalle: "SST Nacional", valor: "SSTN" },
            { detalle: "SST Provincia de Córdoba", valor: "SSTP" },
            { detalle: "SST Municipalidad de Córdoba", valor: "SSTM" },
            { detalle: "SST CABA", valor: "SSTCABA" },
            { detalle: "Todos", valor: "" },
        ],

        showInforme: false,
        showEditar: false,
        showGenerar: false,
        loadtable: false,
        headers: [
            {
                text: "Fecha",
                align: "center",
                sortable: false,
                value: "fecha",
            },
            { text: "Sitio Evaluado", value: "sitio", sortable: false },
            { text: "Referencia", value: "referencia", sortable: false },
            { text: "Tipo de Evaluación", value: "tipo", align: "center", sortable: false },
            { text: "EI 303 N° rev.", value: "revision", align: "center", sortable: false },
            { text: "Evaluador", value: "evaluador", sortable: false },
            { text: "Estado", value: "estado", align: "center", sortable: false },
            { text: "Ver / Editar", value: "ver", align: "center", width: "5%", sortable: false },
        ],
    }),
    computed: {
        show: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        verInforme(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showInforme = true;
        },
        editarInforme(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEditar = true;
        },
        generarInforme(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showGenerar = true;
        },

        cargarListado() {
            this.loadtable = true;
            const estado = this.filtroestado;
            const referencia = this.filtroreferencia;
            const sitio = this.filtrositio;
            const evaluador = this.filtroevaluador;
            const tipo = this.filtrotipo;

            let self = this;
            axios
                .get("/Sgi/ListadoEvaluacionCumplimiento?", {
                    params: {
                        estado: estado,
                        tipo: tipo,
                        sitio: sitio,
                        evaluador: evaluador,
                        referencia: referencia
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                    console.log(self.listado)
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },
    },
};
</script>